"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _rowItem = _interopRequireDefault(require("./row-item"));
var _navigation = _interopRequireDefault(require("./common/navigation"));
var _headRowMobile = _interopRequireDefault(require("./rows/mobile/head-row-mobile"));
var _bodyRowMobile = _interopRequireDefault(require("./rows/mobile/body-row-mobile"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

function whichChild(i) {
  return `
  [role='cell']:nth-child(${i}) {
      background-color: ${_intents.default.ux.box.backgroundColor};
    }
  `;
}
const Root = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Root",
  class: "pl-r1cxcnnv"
});
const HeadineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadineWrapper",
  class: "pl-h1p4dwvv"
});
const Table = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Table",
  class: "pl-t1q7lm0s",
  vars: {
    "t1q7lm0s-10": [({
      col
    }) => col === 2 ? '1440px' : 'unset'],
    "t1q7lm0s-12": [({
      col
    }) => col === 2 ? '1920px' : 'unset']
  }
});
const BottomDescription = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BottomDescription",
  class: "pl-b1yil8k3"
});

/**
 * ComparisonChartSection Component.
 *
 *  *  * The ComparisonChartSection uses the following local intents to style the Highlighted Column:
 * Flag Colors:
 * - background-color: intents.ux.box.borderColor
 * - color: intents.ux.box.foregroundColor
 * Highlighted Column Background:
 * - intents.ux.box.backgroundColor data-partial='highlight-primary'
 * - intents.ux.box.foregroundColor
 * You can add the above intents to your theme if you want to have more control over the styling of the
 * highlighted Column.
 *
 * @param {Object} props React props
 * @param {String} props._name Impression tracking name
 * @param {Array} props.rows Array of row items desktop and mobile
 * @param {string} props.verticalMargin Vertical Outer Spacing value
 * @returns {React.ReactElement} ComparisonChartSection Component
 * @public
 */

function ComparisonChartSection({
  _name,
  rows,
  bottomDescription,
  verticalMargin,
  partial = 'highlight-primary',
  ...rest
}) {
  const headerRow = rows?.find(row => row.rowType === 'header');
  const navigationItems = [...(headerRow?.items || [])];
  const itemWithFlag = headerRow?.items?.findIndex(item => item?.flagText);
  const highlightCondtion = itemWithFlag !== -1 ? itemWithFlag + 1 : Number(headerRow?.selected);
  const [toggleState, setToggleState] = (0, _react.useState)(highlightCondtion);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const {
    heading
  } = {
    ...rest
  };
  function handleFilter(e) {
    setToggleState(e);
  }
  return /*#__PURE__*/_react.default.createElement(Root, {
    _name: _name,
    dataCy: "comparison-chart",
    padding: "none",
    verticalMargin: verticalMargin
  }, heading && /*#__PURE__*/_react.default.createElement(HeadineWrapper, {
    "data-cy": "headline-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, rest)), /*#__PURE__*/_react.default.createElement(Table, {
    role: "table",
    "data-flag": toggleState,
    col: navigationItems?.length
  }, navigationItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_navigation.default, {
    items: navigationItems,
    disableSticky: headerRow?.disableSticky,
    skipOffsetForNav: headerRow?.skipOffsetForNav,
    toggleState: toggleState,
    setFilter: handleFilter
  }), /*#__PURE__*/_react.default.createElement("div", {
    role: "rowgroup",
    "data-partial": partial
  }, rows?.map((item, idx) => {
    // eslint-disable-next-line no-nested-ternary
    const Render = width > _patternLibraryUtils.size.tabletLg ? _rowItem.default : item?.rowType === 'header' ? _headRowMobile.default : _bodyRowMobile.default;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(Render, (0, _extends2.default)({
      key: idx,
      toggleState: toggleState,
      selected: highlightCondtion
    }, item)));
  }))), bottomDescription && /*#__PURE__*/_react.default.createElement(BottomDescription, {
    "data-cy": "bottom-description"
  }, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    text: bottomDescription
  })));
}
var _default = exports.default = ComparisonChartSection;
ComparisonChartSection.propTypes = {
  _name: _propTypes.default.string,
  rows: _propTypes.default.array,
  partial: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};